'use client';

import { c as _c } from "react/compiler-runtime";
import type { Api } from '@cruz-com/lookup';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { Button, CruzIcon } from '@/components';
import { encodeQuery } from '@/lib/encodeQuery';
export function NoResult(t0) {
  const $ = _c(33);
  const {
    meta
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const params = useSearchParams();
  let t1;
  if ($[0] !== meta) {
    t1 = meta || {};
    $[0] = meta;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    total_records_matched_global,
    location
  } = t1;
  const tMatchedGlobal = total_records_matched_global || 0;
  let t2;
  if ($[2] !== params || $[3] !== pathname || $[4] !== router) {
    t2 = () => {
      const queryStr = encodeQuery({
        ...Object.fromEntries(params),
        radius: -1,
        page_number: 1
      });
      router.push(`${pathname}?${queryStr}`);
    };
    $[2] = params;
    $[3] = pathname;
    $[4] = router;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const searchNationwide = t2;
  if (tMatchedGlobal === 0) {
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <section className="mt-4 rounded border p-8 text-center" aria-live="polite">No vehicle matched. Please adjust your filters and try again.</section>;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t3;
  if ($[7] !== location) {
    t3 = location || {};
    $[7] = location;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    city,
    state_abbr,
    distance
  } = t3;
  let t4;
  if ($[9] !== distance) {
    t4 = distance?.toLocaleString();
    $[9] = distance;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <span className="font-semibold">{t4} miles</span>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== city || $[14] !== state_abbr) {
    t6 = <span className="font-semibold">{city}, {state_abbr}</span>;
    $[13] = city;
    $[14] = state_abbr;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <div className="m-0 mb-6 text-center">No vehicle matched within {t5} of{" "}{t6}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <CruzIcon.Tips className="size-7" />;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== tMatchedGlobal) {
    t9 = tMatchedGlobal.toLocaleString();
    $[20] = tMatchedGlobal;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <div className="m-0"><span className="font-semibold">{t9}</span> vehicles found nationwide</div>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <CruzIcon.Search />;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== searchNationwide) {
    t12 = <Button className="h-9 rounded-full px-5" onClick={searchNationwide}>{t11}Search Nationwide</Button>;
    $[25] = searchNationwide;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t10 || $[28] !== t12) {
    t13 = <div className="flex items-center justify-center gap-x-5">{t8}{t10}{t12}</div>;
    $[27] = t10;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t7) {
    t14 = <section className="mt-4 rounded border p-8 font-light" aria-live="polite">{t7}{t13}</section>;
    $[30] = t13;
    $[31] = t7;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
}